/**
 * The gate for anchored notes: true only when the content URL is a direct
 * video file we can play in a native `<video>` (the BE's presigned S3 MP4).
 * YouTube / Vimeo embeds, Drive links, images and blob URLs are all false,
 * so those surfaces keep today's panel untouched.
 */
const DIRECT_VIDEO_FILE = /\.(mp4|webm|ogg|mov|m4v)(\?|$)/i;
const EMBED_HOSTS = /(^|\.)(youtube\.com|youtu\.be|youtube-nocookie\.com|vimeo\.com)$/i;
const HTTP_SCHEMES = new Set(['http:', 'https:']);

export function isNativeReviewable(url: string | undefined): boolean {
  if (!url) return false;
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return false;
  }
  if (!HTTP_SCHEMES.has(parsed.protocol)) return false;
  if (EMBED_HOSTS.test(parsed.hostname)) return false;
  return DIRECT_VIDEO_FILE.test(url);
}
